<template>

    <div>
        <div class="flex flex-wrap items-stretch p-4">
            <div class="flex-1 w-1/2 mx-1 border rounded shadow"
                 v-for="(value, key) in trolley"
            >
                <shopping-trolley-panel :component="value" :title="key" :is-lever="isLever"></shopping-trolley-panel>
            </div>
        </div>

        <div class="mb-4">
            <div class="p-2"
                 v-for="(value, key) in fixings"
            >
                <shopping-trolley-fixing-panel :component="value" :title="key" :is-lever="isLever"></shopping-trolley-fixing-panel>
            </div>
        </div>
    </div>
</template>

<script>

    import ShoppingTrolleyPanel from './ShoppingTrolleyPanel';
    import ShoppingTrolleyFixingPanel from './ShoppingTrolleyFixingPanel';

    export default {

        props: ['StringLayout', 'is-lever'],

        components: {ShoppingTrolleyPanel, ShoppingTrolleyFixingPanel},

        data() {
            return {
                trolley: [],
                fixings: []
            }
        },

        created() {
            this.getTrolley(this.StringLayout);
            this.getFixings(this.StringLayout);
        },

        methods: {
            getTrolley(id) {
                axios.get('/strings-layouts/' + id + '/shopping-trolley')
                    .then((response) => this.trolley = response.data);
            },

            getFixings(id) {
                axios.get('/strings-layouts/' + id + '/fixings')
                    .then((response) => this.fixings = response.data)
            },

            imClosing() {
                this.$emit('im-closing');
            }

        }

    }
</script>